import { Col, Image, Input, Row, Typography } from 'antd';

import { Link } from 'react-router-dom';
import CollectionAvatarUpload from '../CollectionAvatarUpload';
import CollectionInfoCardActions from './CollectionInfoCardActions';


const { Search } = Input;
const { Paragraph, Text, Title } = Typography;

const CollectionInfoCard = ({ collection, collectionNetPrice, hasAccessToEntireCollection=false, moduleAccess, mode="purchase", type='default'}) => {
    
    const CollectionCoverImage = () => {
        if(mode === "purchase" && type === 'list'){
            return <Link to={`/collections/${collection.id}`}>
                <Image 
                    src={collection.coverImage.image}
                    preview={false}
                    width={"100%"}
                />
            </Link>
        } else if(mode === "preview"){
            return <div className="collection-info-card-preview-image"><Title level={3}>You can upload a cover image after creating your collection</Title></div> 
        } else {
            return <Image 
                        src={collection.coverImage.image}
                        preview={false}
                        width={"100%"}
                    />
        }
    }

    const CollectionTitle = () => {
        if(mode === "purchase" && type === "list"){
            return <Link to={`/collections/${collection.id}`}>
                        <Title level={4} className="collection-info-card-title">{collection.name}</Title>
                    </Link>
        }

        return <Title level={4} className="collection-info-card-title">{collection.name}</Title>
    }

    return <div className="collection-info-card">
        <Row>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                {
                    mode === "instructor" ? <CollectionAvatarUpload
                                                collectionId={collection.id} 
                                                existingCoverImage={collection.coverImage.image} 
                                            /> : <CollectionCoverImage />
                }
                
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <div className="collection-info-card-text-container">
                    <CollectionTitle />
                    {
                        mode === "preview" ? <Text type="secondary">{`${collection.primaryAuthor.firstName} ${collection.primaryAuthor.lastName}`}</Text>
                        : <Text type="secondary">By <Link to={`/creators/${collection.primaryAuthor.id}`}>{`${collection.primaryAuthor.firstName} ${collection.primaryAuthor.lastName}`}</Link></Text>
                    }
                    {
                        mode === "preview" ? <Text type="secondary">{ collection.coAuthors.map(coAuthor => <Text key={coAuthor.id} type="secondary">{`, ${coAuthor.firstName} ${coAuthor.lastName}`}</Text>) }</Text>
                        : <Text type="secondary">{ collection.coAuthors.map(coAuthor => <Text key={coAuthor.id}><Link to={`/creators/${coAuthor.id}`}>{`, ${coAuthor.firstName} ${coAuthor.lastName}`}</Link></Text>) }</Text>

                    }
                    <Paragraph className="collection-info-card-description">
                        <Text type="secondary">{collection.description}</Text>
                    </Paragraph>
                    <Paragraph className="collection-info-card-long-description">
                        {collection.longDescription}
                    </Paragraph>
                    <Paragraph>
                        <Text>Total Value: {collection.valuePrice} cupoints</Text>
                    </Paragraph>

                    <CollectionInfoCardActions 
                        collection={collection}
                        collectionNetPrice={collectionNetPrice}
                        hasAccessToEntireCollection={hasAccessToEntireCollection}
                        mode={mode}
                        type={type}
                    />

                   
                </div>
            </Col>
            
        </Row>
    </div>
}

export default CollectionInfoCard;